module.exports = __webpack_public_path__ + "img/team-1.d61bb396.webp";